import * as React from "react";
import {graphql, Link} from "gatsby";
import Blog from "../views/Blog";
import * as styles from "../styles/posts.module.scss";
import {FiChevronLeft} from "@react-icons/all-files/fi/FiChevronLeft";
import {FiChevronRight} from "@react-icons/all-files/fi/FiChevronRight";
import Layout from "../components/Layout";
import {useTranslation} from "react-i18next";
import DefaultHeader from "../components/DefaultHeader";

const AllPosts = ({pageContext, data}) => {
	const {t} = useTranslation();
	const {currentPage, numPages} = pageContext;
	const isFirst = currentPage === 1;
	const isLast = currentPage === numPages;
	const prevPage =
		currentPage - 1 === 1 ? "/posts" : "/posts/" + (currentPage - 1).toString();
	const nextPage = "/posts/" + (currentPage + 1).toString();

	const posts = data.allMdx.edges;
	// var getPageNumberPath = null;
	const getPageNumberPath = (currentIndex) => {
		if (currentIndex === 0) {
			return "/posts";
		}

		return "/posts/" + (currentIndex + 1);
	};

	return (
		<Layout title={t('Posts')}>
			<div className="w-full ">
				<DefaultHeader
					backgroundClass="post-bg"
					breadcrumbs={[
						{
							title: t('Posts'),
							path: `posts`,
						}
					]}
					title={t('Posts')}
				/>
				<div className="max-w-6xl mx-auto py-28">
					<div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 ">
						{posts.map((post) => {
							return (
								<Blog
									key={post.node.frontmatter.slug}
									date={post.node.frontmatter.date}
									title={post.node.frontmatter.title}
									description={post.node.frontmatter.description}
									slug={post.node.frontmatter.slug}
									blogImage={
										post.node.frontmatter.ogImage !== null &&
										post.node.frontmatter.ogImage.publicURL !== null
											? post.node.frontmatter.ogImage.publicURL
											: null
									}
								/>
							);
						})}
					</div>
				</div>
				<div className={styles.paginationWrapper}>
					<Link
						className={
							isFirst ? styles.disabledButton : styles.nextPageClassName
						}
						to={prevPage}
						rel="prev"
					>
            <span>
              <FiChevronLeft className={styles.nextPrev}/>
            </span>
					</Link>
					{Array.from({length: numPages}, (_, i) => {
						let pageNumberClassName = styles.paginationNumber;
						if (currentPage === i + 1) {
							pageNumberClassName = styles.currentPageNumber;
						}

						return (
							<Link key={i + 1} to={getPageNumberPath(i)}>
								<span
									className={
										pageNumberClassName
											? pageNumberClassName
											: styles.paginationNumber
									}
								>
									{i + 1}
								</span>
							</Link>
						);
					})}
					<Link
						className={
							isLast ? styles.disabledButton : styles.nextPageClassName
						}
						to={nextPage}
						rel="next"
					>
            <span>
              <FiChevronRight className={styles.nextPrev}/>
            </span>
					</Link>
				</div>
			</div>
		</Layout>
	);
};

export default AllPosts;

export const pageQuery = graphql`
	query AllPostsQuery($locale: String!, $skip: Int!, $limit: Int!, $layout: String!) {
		allMdx(
			filter: {frontmatter: {locale: {eq: $locale}, layout: {eq: $layout}}},
			sort: {fields: frontmatter___date, order: DESC}
			skip: $skip
			limit: $limit
		) {
			edges {
				node {
					frontmatter {
						date
						slug
						title
						tags
						description
						locale
						ogImage {
							publicURL
						}
					}
				}
			}
		}

		locales: allLocale(filter: {language: {eq: $locale}}) {
			edges {
				node {
					ns
					data
					language
				}
			}
		}
	}
`;
